import {Grid, Icon, ListView, WingBlank} from 'antd-mobile';
//import { StickyContainer, Sticky } from 'react-sticky';
import './Games_Swiper.css';
import CONF_LAN from "./config/LAN";
class GamesSwiper extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        var swiper = new Swiper('.games-swiper', {
            autoplay : true,
            slidesPerView: ($('.games-swiper .swiper-slide').length>3?3:$('.games-swiper .swiper-slide').length),
            spaceBetween: window.lib.flexible.rem2px(0.28),
            loop:true,
            pagination: {
                el: '.games-swiper .swiper-pagination',
            },
        });
        let ih=window.lib.flexible.rem2px(10-2*0.28)/3*348/251;
        $('.games-swiper .swiper-slide').css('height',ih+'px');
        $(document).on('click', '.games-swiper .swiper-slide', function () {
            var url = $(this).attr('data-url');
            window.location.href=(url);
        });

    }

    onClick=(v)=>{
        console.log(v)
    }
    render(){
        let that=this;
        let {data}=this.props;
        let swiperSliders=data.map(function (v) {
           return (<img className="swiper-slide" data-ptt={v.ptt} data-url={v.href} src={v.icon}></img>);
        })
        return (<div className="games-swiper swiper-container">
                    <div className="swiper-wrapper">
                        {swiperSliders}
                    </div>
                    <div className="swiper-pagination"></div>
                </div>);

    }
}
class GamesComp extends React.Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {

    }
    render() {
        let {data}=this.props;
        return (
            //<WingBlank size="sm">
                <div
                    className="sticky-container games"
                    style={{ zIndex: 4 }}
                >
                    {/* Other elements can be in between `StickyContainer` and `Sticky`,
        but certain styles can break the positioning logic used. */}
                    <div
                    >
                        <div  className="am-list-item am-list-item-middle">
                            <div className="am-list-line">
                                <div className="am-list-content">
                                    <div>
                                        <div style={{"padding-bottom":"0px"}}></div>
                                        <div
                                            className="sticky games-title-bg"
                                            style={{
                                                zIndex: 4,
                                            }}
                                        >
                                            <img className={'title-img games-title-img'} src={CONF_LAN[CUR_LAN]['img_dir']+'Games_title.png'} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <GamesSwiper data={data}/>
                </div>


            //</WingBlank>
        );
    }
}
export default  GamesComp;